import { z } from "zod";
import { DateTimeStringWithOffset, DateTimeWithOffset } from "@/lib/api/schemas/patterns";

/** A Tapioca client (workspace) an MCP connection can be pinned to. */
export const McpClientChoiceOut = z.object({
  id: z.number(),
  name: z.string(),
});

/** What the consent screen shows for one pending authorization request. */
export const McpAuthorizationOut = z.object({
  id: z.string().uuid(),
  client_name: z.string(),
  /** Where the browser goes back to; shown so the user can tell the real app from a lookalike. */
  redirect_host: z.string(),
  scopes: z.array(z.string()),
  expires_at: DateTimeStringWithOffset,
  /** The user connected this app before: "restore access" rather than a first-time "connect". */
  reconnect: z.boolean(),
  /** A superuser: the connection sees every client and there is nothing to pick. */
  all_clients: z.boolean(),
  /** Empty for a superuser. */
  clients: z.array(McpClientChoiceOut),
  /** Preselected: the client the user works in now. */
  client_id: z.number().nullable(),
});

/** Left out, `client_id` means the client the user works in now; a superuser's is ignored. */
export const McpApproveIn = z.object({
  client_id: z.number().int().nullish(),
});

/** Answer to approve and deny alike. */
export const McpRedirectOut = z.object({
  redirect_url: z.string().url(),
});

/** An app signed in as this user. */
export const McpConnectionOut = z.object({
  /** The grant; DELETE it to disconnect. */
  id: z.string().uuid(),
  client_name: z.string(),
  /** `null`: every client (a superuser's connection). */
  workspace: McpClientChoiceOut.nullable(),
  connected_at: DateTimeWithOffset,
  last_used_at: DateTimeWithOffset.nullable(),
});
